define(['backbone'], (Backbone) => Backbone.View.extend({
    events: {
        click: 'clicked'
    },

    initialize () {
        this.listenTo(this.model, 'change:selected', this.select);
    },

    render () {
        this.$el.empty().text(this.model.get(this.options.name));

        if (this.options.inline) {
            this.$el.css({display: 'inline-block'});
        } else {
            this.$el.css({float: 'left'});
        }

        if (this.options.noMargin) {
            this.$el.css({'margin-right': 0});
        }
        if (this.options.width) {
            this.$el.css({width: this.options.width});
        }
        if (this.options.height) {
            this.$el.css({height: this.options.height});
        }

        return this;
    },

    clicked () {
        this.model.set('selected', !this.model.get('selected'));
        this.options.parent.trigger('change');
    },

    select (model, value) {
        this.$el.toggleClass('active', value);
    }
}));
